@use "styles" as *;
@use "~photoswipe/dist/photoswipe.css";

[data-me-lightbox-toggle] {
  cursor: pointer;
}

.me-lightbox__share-icon {
  color: $color-white;
}
